// import _ from "lodash";
import { destroyBlockingUI } from '../errors/globalFeedbackBridge';
import store from '../flux/store/index';
import { actionTypes } from '../flux/action/actionTypes';
import { getSessionStorage } from '@utils/windowUtil';
import { resetChatbotWsSession } from '../aiChat/ws/chatbotWsScope';

const isValuesEqual = (propNames, nextProps, props) => {
  for (let i = 0, len = propNames.length; i < len; i++) {
    const propName = propNames[i];

    if (nextProps[propName] !== props[propName]) {
      return true;
    }
  }

  return false;
};

const getWrappedInstance = (instance) => {
  if (instance && instance.constructor && instance.getWrappedInstance) {
    return instance.getWrappedInstance();
  }
  return instance;
};

const validateLogin = () => {
  // console.log('====>', window.localStorage);
  const idToken =
      window.localStorage.getItem('idToken') ||
      window.localStorage.getItem('accessToken'),
    expiredAt = window.localStorage.getItem('expired'),
    userInfo = window.localStorage.getItem('userInfo');

  const status = Boolean(
    idToken && userInfo && Number(expiredAt) > Date.parse(new Date()),
  );

  if (!status) {
    window.localStorage.removeItem('idToken');
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('refreshToken');
    window.localStorage.removeItem('userInfo');
  }

  // return status || process.env.NODE_ENV === 'development';
  return status;
};

const clearTokens = () => {
  resetChatbotWsSession();
  window.sessionStorage.removeItem('loginProgress');
  window.localStorage.removeItem('accessToken');
  window.SessionStorage.removeItem('loginProgress');
  window.localStorage.removeItem('accessToken');
  window.localStorage.removeItem('refreshToken');
};

const getAccessTokenFromStorage = () => {
  const storage = window.localStorage.getItem('accessToken');

  try {
    const { accessToken, expired } = JSON.parse(storage);
    if (accessToken && expired > Date.parse(new Date())) {
      return accessToken;
    }

    return undefined;
  } catch (error) {
    return undefined;
  }
};
const deepCopy = (target) => {
  const copyed_objs = [];
  function _deepCopy(target) {
    if (typeof target !== 'object' || !target) {
      return target;
    }
    for (let i = 0; i < copyed_objs.length; i++) {
      if (copyed_objs[i].target === target) {
        return copyed_objs[i].copyTarget;
      }
    }
    let obj = {};
    if (Array.isArray(target)) {
      obj = [];
    }
    copyed_objs.push({ target, copyTarget: obj });
    Object.keys(target).forEach((key) => {
      if (obj[key]) {
        return;
      }
      obj[key] = _deepCopy(target[key]);
    });
    return obj;
  }
  return _deepCopy(target);
};

const delay = (cb, time = 1000) =>
  new Promise((resolve) => {
    setTimeout(() => {
      const result = typeof cb === 'function' ? cb() : cb;
      resolve(result);
    }, time);
  });

const stopPropagation = (e) => e?.stopPropagation?.();

// 页面滚动的函数
const scrollToTopAnimation = (obj = {}) => {
  const { msec = 6, stepSpace = 10, x = 0, y = 0 } = obj;
  // msec:滚动时间,stepSpace:滚动步距,x:横向滚动的距离,Y:纵行滚动的距离
  let currentPosition, timer;
  timer = setInterval(function () {
    currentPosition =
      document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition -= stepSpace;
    if (currentPosition > y) {
      window.scrollTo(x, currentPosition);
    } else {
      window.scrollTo(x, y);
      clearInterval(timer);
    }
  }, msec);
};
// 截取句子中的letter
const sliceStr = (obj = {}) => {
  const { str = '', num = 100 } = obj;
  // str:传进来的字符串,num:限制的letter数。
  if (typeof str !== 'string') {
    return console.warn('Please enter a string type！');
  }
  if (str.length <= num) {
    return str;
  }
  let newStr = str.substring(0, num);
  if (str.charAt(num) && str.charAt(num) !== ' ') {
    return (newStr = str.substring(0, newStr.lastIndexOf(' ')));
  }
  // newStr的长度小于等于num,因为末尾去除了不完整的word。
  return newStr;
};

// 判断url是否有http，如果没有，自动添加
const addHTTP = (str, mark) => {
  if (typeof str !== 'string') {
    return console.warn('Please enter a string type！');
  }
  const newStr = str.substring(0, 4);
  return newStr === 'http' ? str : mark + str;
};

const spliceString = (str, num, mark) => {
  if (str.length <= num) {
    return str;
  }
  return str.substring(0, num) + mark;
};

const queryURLParams = (url, splitText = '&&') => {
  const asktext = url.substring(url.indexOf('?') + 1, url.length);
  if (!asktext) {
    return {};
  }
  const result = {};
  const askary = asktext.split(splitText);
  askary.forEach((item) => {
    const n = item.split('=');
    const key = n[0];
    const value = n[1];
    result[key] = value;
  });
  return result;
};

// const getEnhancedUrlSearch = (projectId) =>
//   `?${encodeURIComponent(
//     `currentId=${projectId}&&projectName=${getSessionStorage(
//       'projectName',
//     )}`,
//   )}`;

const generateProjectUrlSearch = (projectId) => {
  const search = new URLSearchParams({
    projectId: projectId || getSessionStorage('currentId'),
    // projectName: projectName || getSessionStorage('projectName'),
  });
  return search.toString();
};

const transRem2Px = (remMultiple = 0) => {
  const BASE =
    getComputedStyle(document.documentElement)['font-size'].replace('px', '') ||
    16;

  return remMultiple * BASE;
};

const formatCreateProjectDate = (year, month, day) => {
  const formatMonth = month < 10 ? `0${month}` : month;
  const formatDay = day < 10 ? `0${day}` : day;
  return `${year}-${formatMonth}-${formatDay}`;
};

const rgbToHex = (r, g, b) => {
  const hex = ((r << 16) | (g << 8) | b).toString(16);
  return `#${new Array(Math.abs(hex.length - 7)).join('0')}${hex}`;
};

const hexToRgb = (hex) => {
  const rgb = [];
  for (let i = 1; i < 7; i += 2) {
    rgb.push(parseInt(`0x${hex.slice(i, i + 2)}`));
  }
  return rgb;
};

const gradientColorStep = (startColor, centerColor, endColor, step) => {
  if (!startColor || !centerColor || !endColor || !step) {
    return [];
  }
  const middle = step / 2;
  const sColor = hexToRgb(startColor);
  const cColor = hexToRgb(centerColor);
  const eColor = hexToRgb(endColor);

  const colors = [];
  for (let i = 0; i < step; i++) {
    let rStep = 0;
    let gStep = 0;
    let bStep = 0;
    if (i <= middle) {
      rStep = (cColor[0] - sColor[0]) / middle;
      gStep = (cColor[1] - sColor[1]) / middle;
      bStep = (cColor[2] - sColor[2]) / middle;
      colors.push(
        rgbToHex(
          parseInt(rStep * i + sColor[0]),
          parseInt(gStep * i + sColor[1]),
          parseInt(bStep * i + sColor[2]),
        ),
      );
    } else {
      rStep = (eColor[0] - cColor[0]) / middle;
      gStep = (eColor[1] - cColor[1]) / middle;
      bStep = (eColor[2] - cColor[2]) / middle;
      colors.push(
        rgbToHex(
          parseInt(rStep * (i - middle) + cColor[0]),
          parseInt(gStep * (i - middle) + cColor[1]),
          parseInt(bStep * (i - middle) + cColor[2]),
        ),
      );
    }
  }
  return colors;
};

const capitalizeFirstLetter = (string) =>
  string ? string.charAt(0).toUpperCase() + string.slice(1) : '';

const exchangeKeyVInObj = (obj) => {
  const res = {};
  for (const k in obj) {
    const value = obj[k];
    res[value] = k;
  }
  return res;
};

const SessionTimeoutClassName = 'session-timeout-modal';
// const showSessionTimeoutModal = () => {
//   const modalCount = document.getElementsByClassName(SessionTimeoutClassName);
//   if (modalCount.length > 0) {
//     return;
//   }
//   store.dispatch({
//     type: actionTypes.login.CHANGE_SESSION_TIMEOUT,
//     payload: true,
//   });
//   Modal.destroyAll();

//   clearTokens();
//   window.SessionStorage.removeItem('currentId');
//   // setSessionStorage(
//   //   'from',
//   //   window.location.pathname + window.location.search,
//   // );
//   window.localStorage.setItem('from', encodeURIComponent(window.location.href));
//   window.location.pathname = '/';
//   // alert.error({
//   //   content: LOGIN_ERROR.SESSION_TIMEOUT,
//   //   className: SessionTimeoutClassName,
//   //   onOk: () => {
//   //     clearTokens();
//   //     window.SessionStorage.removeItem('currentId');
//   //     // setSessionStorage(
//   //     //   'from',
//   //     //   window.location.pathname + window.location.search,
//   //     // );
//   //     window.localStorage.setItem('from', encodeURIComponent(window.location.href));
//   //     window.location.pathname = '/';
//   //   },
//   // });
// };

const showSessionTimeoutModal = () => {
  // ✅ One line block check
  if (
    ['/login', '/logout', '/error', '/registration'].some((r) =>
      window.location.pathname.startsWith(r),
    )
  ) {
    clearTokens();
    window.location.pathname = '/';
    return;
  }

  const modalCount = document.getElementsByClassName(SessionTimeoutClassName);
  if (modalCount.length > 0) {
    return;
  }

  store.dispatch({
    type: actionTypes.login.CHANGE_SESSION_TIMEOUT,
    payload: true,
  });
  destroyBlockingUI();

  clearTokens();
  window.SessionStorage.removeItem('currentId');
  window.localStorage.setItem('from', encodeURIComponent(window.location.href));
  window.location.pathname = '/';
};

const addProtocolToLink = (link) => {
  const _link =
    link.trim().indexOf('http://') === 0 ||
    link.trim().indexOf('https://') === 0
      ? link
      : `https://${link}`;
  return _link;
};

const isValidProjectId = (id) => {
  const regExp =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  return typeof id === 'string' && regExp.test(id);
};

const ENVS = {
  PROD: 'prod',
  PREPROD: 'preprod',
  STG: 'stg',
  DEV: 'dev',
  LOCAL: 'local',
};

const CUR_ENV = ((url = '') => {
  if (url.includes('dev-ddv-client')) {
    return ENVS.DEV;
  }
  if (url.includes('stg-dealdashboardintegration')) {
    return ENVS.STG;
  }
  if (url.includes('maintegration-dealdashboard')) {
    return ENVS.PREPROD;
  }
  if (url.includes('gateway-prod')) {
    return ENVS.PROD;
  }
  return ENVS.LOCAL;
})(process.env.REACT_APP_app_url);

// 判断是不是Object【Null在这里不被认为是一个object】
const isObject = (data) =>
  Object.prototype.toString.call(data) !== '[object Object]';

/**
 * Find parent with specific classname for provided node
 * Often used in tooltip or popover to find correct container
 * @param node
 * @param classname
 * @returns {null| Node}
 */
function findParentNode(node, classname) {
  if (!node || node === document.body) {
    return null;
  }
  let currentNode = node;
  while (currentNode && currentNode !== document.body) {
    if (currentNode.classList.contains(classname)) {
      return currentNode;
    }
    currentNode = currentNode.parentNode;
  }
}

const isUuid = (id) =>
  /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(
    id,
  );

// to fix blob pdf page losing inline style
const injectPDFStyleOnIframeLoad = (e) => {
  if (e.target.nodeName === 'IFRAME') {
    const styleEl = document.createElement('style');
    styleEl.nonce = 'NTNlMjMwYjctZWYzMC00MjM2LWFlNDYtN2U5NjZkOTc0Yjk2';
    styleEl.innerText = `body {height: 100%; width: 100%; overflow: hidden; margin:0px; background-color: rgb(82, 86, 89);} embed {position:absolute; left: 0; top: 0;}`;
    e.target.contentDocument.documentElement.appendChild(styleEl);
  }
};

// src/utils/common.js

const clearLocalStorage = () => {
  resetChatbotWsSession();
  // Clear localStorage
  Object.keys(window.localStorage).forEach((key) => {
    if (key !== 'welcomeCardClosed' && key !== 'loginType' && key !== 'from') {
      localStorage.removeItem(key);
    }
  });

  // Clear sessionStorage
  Object.keys(window.sessionStorage).forEach((key) => {
    if (key.startsWith('gateway-') || key === 'from') {
      return;
    }
    sessionStorage.removeItem(key);
  });

  // Clear Storage if it exists
  if (window.localStorage) {
    try {
      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('refreshToken');
      window.localStorage.removeItem('userInfo');
    } catch (e) {
      console.error('Error clearing Storage:', e);
    }
  }

  // Clear SessionStorage if it exists
  if (window.SessionStorage) {
    try {
      window.SessionStorage.removeItem('loginProgress');
      window.SessionStorage.removeItem('redirectPath');
    } catch (e) {
      console.error('Error clearing SessionStorage:', e);
    }
  }
};

const isValidLogin = () => {
  // Check both Storage and localStorage for compatibility
  const accessToken =
    window.localStorage?.getItem('accessToken') ||
    window.localStorage.getItem('accessToken');

  const status = Boolean(accessToken);

  if (!status) {
    clearLocalStorage();
  }

  return status;
};

const isInvalidUserInfo = (userInfo) =>
  !userInfo ||
  !userInfo.uid ||
  !Array.isArray(userInfo?.permissions) ||
  (userInfo && userInfo.exp < Number(new Date()));

const isValidEnv = () =>
  Boolean(
    process &&
      process.env &&
      process.env.REACT_APP_NEW_LOGIN_AUTH_URL &&
      process.env.REACT_APP_NEW_LOGIN_STATE &&
      process.env.REACT_APP_NEW_LOGIN_REDIRECT_URL,
  );

const getFirstPathname = (url) => {
  if (!url) return '';
  if (url.startsWith('/')) return url.split('/')[1];
  if (url.startsWith('http')) {
    try {
      return new URL(url).pathname?.split('/')[1];
    } catch (e) {
      console.log(e);
    }
  }
  return '';
};

//  const getValueFromSearchParam = (... keys) => {
//   const searchParam = new URLSearchParams(window.location.search);
//   return keys.reduce((result, current) => {
//     result[current] = searchParam.get(current);
//     return result;
//   }, {});
// };

export {
  ENVS,
  delay,
  isUuid,
  addHTTP,
  CUR_ENV,
  isObject,
  deepCopy,
  sliceStr,
  clearTokens,
  transRem2Px,
  spliceString,
  isValuesEqual,
  validateLogin,
  queryURLParams,
  findParentNode,
  stopPropagation,
  isValidProjectId,
  addProtocolToLink,
  exchangeKeyVInObj,
  gradientColorStep,
  getWrappedInstance,
  // getEnhancedUrlSearch,
  scrollToTopAnimation,
  capitalizeFirstLetter,
  formatCreateProjectDate,
  showSessionTimeoutModal,
  generateProjectUrlSearch,
  getAccessTokenFromStorage,
  injectPDFStyleOnIframeLoad,
  clearLocalStorage,
  isValidLogin,
  isInvalidUserInfo,
  isValidEnv,
  getFirstPathname,
  // getValueFromSearchParam,
};
